export default __webpack_public_path__ + "static/media/insights.060318f5.svg";